{
  "qr-checkin-config-page": {
    "buttons": {
      "check-in": "CHECK IN"
    },
    "meta": {
      "title": "QR Checkin",
      "description": "Checkin qua mã QR",
      "checkin-hint": "(Không bắt buộc) Bạn có thể chọn dịch vụ trước khi checkin"
    }
  }
}
